import { useMemo } from 'react';
import { LoadingState } from 'shared/LoadingState';

export interface TableComputedStates {
  hasNoItems: boolean;
  hasSearchResults: boolean;
  shouldShowTable: boolean;
}

export interface UseTableStatesProps {
  loadingState: LoadingState;
  itemsLength: number;
  searchTermLength: number;
}

export const useTableStates = ({
  loadingState,
  itemsLength,
  searchTermLength,
}: UseTableStatesProps): TableComputedStates => {
  const { isLoading, hasError } = loadingState;

  return useMemo(
    () => ({
      hasNoItems: !isLoading && !hasError && itemsLength === 0 && searchTermLength === 0,
      hasSearchResults: !isLoading && !hasError && searchTermLength > 0 && itemsLength === 0,
      shouldShowTable: !(!isLoading && !hasError && itemsLength === 0 && searchTermLength === 0),
    }),
    [isLoading, hasError, itemsLength, searchTermLength],
  );
};
